import { route } from '../../helpers';
import { AccountPages } from '../../../constants/AppConstants';

module.exports = route(AccountPages.SMARTCARD_LINK_CONFIRMATION, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../../components/account/smartcard/link/ConfirmAssociation').default);
        }, 'account-smartcard-link-confirmation');
    }
});



// WEBPACK FOOTER //
// ./src/routes/Account/Smartcard/AssociationConfirmation.js